import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=4230f750&scoped=true"
import script from "./UserHistory.vue?vue&type=script&lang=js"
export * from "./UserHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230f750",
  null
  
)

export default component.exports